'use client';
import { ErrorPage } from '@/components/error/error-page';

export default ErrorPage;
